import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ActivityTimeoffFields from './ActivityTimeoffFields'
import CompanyTimeoffFields from './CompanyTimeoffFields'
import ScheduleTimeoffFields from './ScheduleTimeoffFields'
import UsedTimeoffFields from './UsedTimeoffFields'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

export type TimeoffExportType =
  | 'company_timeoff'
  | 'activity_timeoff'
  | 'schedule_timeoff'
  | 'used_timeoff'

const TimeoffTypeSelect = ({ form, onEmployeeSelectionChange }: Props) => {
  const timeoffTypeOptions: { label: string; value: TimeoffExportType }[] = [
    {
      label: i18n.t('employees.reports.timeoff_options.company_timeoff'),
      value: 'company_timeoff',
    },
    {
      label: i18n.t('employees.reports.timeoff_options.used_timeoff'),
      value: 'used_timeoff',
    },
    {
      label: i18n.t('employees.reports.timeoff_options.activity_timeoff'),
      value: 'activity_timeoff',
    },
    {
      label: i18n.t('employees.reports.timeoff_options.schedule_timeoff'),
      value: 'schedule_timeoff',
    },
  ]

  const kind: TimeoffExportType = form.get('kind').value

  return (
    <>
      <FormRow>
        <Box className="sidebar_employees_export_employee_data_timeoff_timeoff_type_button">
          <Select
            label={i18n.t('employees.reports.timeoff_type')}
            field={form.get('kind')}
            options={timeoffTypeOptions}
          />
        </Box>
      </FormRow>

      {kind === 'company_timeoff' && (
        <CompanyTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {kind === 'activity_timeoff' && (
        <ActivityTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {kind === 'used_timeoff' && (
        <UsedTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {kind === 'schedule_timeoff' && (
        <ScheduleTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
    </>
  )
}

export default observer(TimeoffTypeSelect)
